import React from 'react';
import RawMaterialInsert from '../../Models/RawMaterial/Insert';
import AuthService from "../../services/auth.service";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AddRawMaterial(props) {

    const { t } = useTranslation();

    return (
        <div>
            <br />
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item"><Link to={'/RawMaterials/'}>{t("RawMaterials_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item active">{t("Global_Button_Text_New")}</li>
                </ol>
            </nav>
            <br />
            {AuthService.isUSerAdmin() ? (<RawMaterialInsert />) : (
                <div className="jumbotron">
                    <h1 className="display-4">{t("Global_Message_Title_UserNotAllowed")}</h1>
                    <p className="lead">{t("Global_Message_Text_UserNotAllowed")}</p>
                </div>
            )}
            <br />
            <br />
        </div >
    );

}
